// Modules
import * as React from "react";
import { Link } from "gatsby"

// Style
import "./serviceCard.scss";

// Components
import Button from "reactstrap/lib/Button";

// Interfaces
import { IServiceItem } from "src/Interfaces/interfaces";
import { getService } from 'src/helper/helper';
import { withTranslation, WithTranslation } from 'react-i18next';
import i18next, { t } from "i18next";

interface IProps extends WithTranslation {
    prop: any;
  }
  
  interface IState {
    state: any;
  }

class ServiceCard extends React.PureComponent<IServiceItem,IProps , IState> {

    public render() {
        // console.log(`${this.props.pricing.price.replace(' ', '').replace(' ', '').replace('.','').replace('$','').replace('/','')}`)
        // console.log("hihihi" + `${this.props.pricing.price}`)
        
        return (
            <div className={`service-rol col-sm-12 col-md-6 card-deck + ${this.props.lgString || "col-lg-4" }`}>
                <div className="service-card card">
                    <img
                        src={this.props.img}
                        alt={this.props.name}
                        className="service-card__img rounded card-img-top"
                    />
                    <div className="service-card__body card-body">
                        <h3 className="service-card__body__header">{t(`serviceCard.${this.props.name.replace(' ', '-')}.title`)}</h3>
                        <span>{t(`serviceCard.${this.props.name.replace(' ', '-')}.description`)}</span>
                    </div>
                    <div className="service-card__footer rounded card-footer">
                        <div className="service-card__footer__pricingBox rounded w-100">
                            <span className="text-light all-cap" style={{fontSize: "0.8rem" }}>
                                {!this.props.orderNow
                                    ? t(`serviceCard.${this.props.pricing.price.replace(' ', '').replace(' ', '').replace('.','').replace('$','').replace('/','')}.title`)
                                    : t(`serviceCard.${this.props.pricing.price.replace(' ', '').replace(' ', '').replace('.','').replace('$','').replace('/','')}.title`)}
                            </span>
                        </div>
                        
                        {this.props.orderNow ? (
                            <Button className="service-card__footer__cta rounded w-100 button-text text-light all-cap"
                                data-schemeid={this.props.pricing.schemeId}
                                data-scheme={this.props.pricing.scheme}
                                onClick={getService}>
                                {t(`serviceCard.Order-Now.title`)}
                            </Button>
                        ) : (
                            this.props.link ? (
                                <Link to={this.props.link}><Button className="service-card__footer__cta rounded w-100 button-text text-light all-cap">
                                {t(`serviceCard.Contact-Us.title`)}
                        </Button></Link>
                            ) : (
<a href="mailto:sales@centreo.hk">
                                    <Button className="service-card__footer__cta rounded w-100 button-text text-light all-cap">
                                    {t(`serviceCard.Contact-Us.title`)}
                                </Button>
                                </a>
                            )
                                
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('info')(ServiceCard)